module.exports = __webpack_public_path__ + "static/img/logo_03.f258915.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo_03.gif
// module id = UoUf
// module chunks = 105